module.exports = __webpack_public_path__ + "static/logos-tech-mobile-dc17087602b26bd69e5b28b3da74a58f.png";